import StringIndex from "../../../util/StringIndex"
import {HierarchyLevels} from "constants"
import {createTokensHighlighterForSearch} from "../../../util/TokensHighlighter"
import messageResource from "../../../messageResource"
import {escapeHtmlSymbols, stringComparator} from '../../../atUtils'
import {customerNameLower, projectNameLower, taskNameLower} from '../../../util/pluralizeUtils'

export const filterIdsBySearch = (ids, entities, search) => {
    let searchIds = ids

    if (search) {
        const stringIndex = new StringIndex()
        for (let id of searchIds) {
            const entity = entities[id]
            stringIndex.add(entity.name, entity.id)
        }
        const tokens = stringIndex.getTokenizer().getTokens(search.toLowerCase())
        searchIds = Object.keys(stringIndex.search(tokens)).map(a => parseInt(a))
    }
    return searchIds
}

export const createNodesForCustomerList = (nodeEntities, searchText, revokeMap, isShowArchived) => {
    const tokensHighlighter = createTokensHighlighterForSearch(searchText)
    const customerRevoked = revokeMap[HierarchyLevels.CUSTOMER]
    const nodeProperties = []
    let countArchiveCustomers = 0

    for (let entity of nodeEntities) {

        if (!isShowArchived && entity.archived) {
            countArchiveCustomers++
            continue
        }

        nodeProperties.push(getCustomerNodeProperty({
                entity,
                isShowArchived,
                tokensHighlighter,
                customerRevoked,
                hierarchyLevel: HierarchyLevels.CUSTOMER
            })
        )
    }

    countArchiveCustomers && nodeProperties.push(
        getNodeProperty({
            isShowArchived,
            entity: {},
            highlightedTitle: messageResource.getEscapedMessage("panel.common.archived_customers", [countArchiveCustomers]),
            additionalClass: "customer_row_archived",
        })
    )

    return nodeProperties
}

export const entirelyAssignedCustomerTitle = (currentLevel, prevLevel) => {
    return ""
}

export const entirelyAssignedProjectTitle = (currentLevel, prevLevel) => {
    const message = "work_assignments.panel.projects.entirely"
    return (currentLevel !== 0)
        ? messageResource.getMessage(message, [
            currentLevel,
            projectNameLower(currentLevel),
            prevLevel,
            customerNameLower(prevLevel)
        ])
        : ""
}

export const entirelyAssignedTaskTitle = (currentLevel, prevLevel) => {
    const message = "work_assignments.panel.tasks.entirely"
    return (currentLevel !== 0)
        ? messageResource.getMessage(message, [
            currentLevel,
            taskNameLower(currentLevel),
            prevLevel,
            projectNameLower(prevLevel)
        ])
        : ""
}

export const createNodesForProjectList = (nodeEntities, searchText, revokeMap, isShowArchived) => {
    const tokensHighlighter = createTokensHighlighterForSearch(searchText)
    const nodeProperties = []
    const customerRevoked = revokeMap[HierarchyLevels.CUSTOMER]
    const projectRevoked = revokeMap[HierarchyLevels.PROJECT]
    let countArchiveProject = 0

    for (let entity of nodeEntities) {

        let nodeProperty = {}

        if (!isShowArchived && entity.archived) {
            entity.type === HierarchyLevels.PROJECT && countArchiveProject++
            continue
        }

        switch (entity.type) {
            case HierarchyLevels.CUSTOMER:
                nodeProperty = getCustomerNodeProperty({
                    entity,
                    isShowArchived,
                    customerRevoked,
                    hierarchyLevel: HierarchyLevels.PROJECT
                })
                break
            case HierarchyLevels.PROJECT:
                nodeProperty = getProjectNodeProperty({
                    entity,
                    isShowArchived,
                    tokensHighlighter,
                    projectRevoked,
                    hierarchyLevel: HierarchyLevels.PROJECT
                })
                break
        }

        nodeProperties.push(nodeProperty)
    }

    countArchiveProject && nodeProperties.push(
        getNodeProperty({
            isShowArchived,
            entity: {},
            highlightedTitle: messageResource.getEscapedMessage("panel.common.archived_projects", [countArchiveProject]),
            additionalClass: "customer_row_archived",
        })
    )

    return nodeProperties
}

export const createNodesForTaskList = (nodeEntities, searchText, revokeMap, isShowArchived) => {
    const tokensHighlighter = createTokensHighlighterForSearch(searchText)
    const nodeProperties = []
    const customerRevoked = revokeMap[HierarchyLevels.CUSTOMER]
    const projectRevoked = revokeMap[HierarchyLevels.PROJECT]
    const taskRevoked = revokeMap[HierarchyLevels.TASK]

    let countCompletedTask = 0

    for (let entity of nodeEntities) {

        if (!isShowArchived && (entity.completed || entity.archived)) {
            entity.type === HierarchyLevels.TASK && countCompletedTask++
            continue
        }

        let nodeProperty = {}

        switch (entity.type) {
            case HierarchyLevels.CUSTOMER:
                nodeProperty = getCustomerNodeProperty({
                    entity,
                    isShowArchived,
                    customerRevoked,
                    hierarchyLevel: HierarchyLevels.TASK
                })
                break
            case HierarchyLevels.PROJECT:
                nodeProperty = getProjectNodeProperty({
                    entity,
                    isShowArchived,
                    projectRevoked,
                    hierarchyLevel: HierarchyLevels.TASK
                })
                break
            case HierarchyLevels.TASK:
                nodeProperty = getTaskNodeProperty({
                    entity,
                    isShowArchived,
                    tokensHighlighter,
                    taskRevoked
                })
                break
        }

        nodeProperties.push(nodeProperty)
    }

    countCompletedTask && nodeProperties.push(
        getNodeProperty({
            isShowArchived,
            entity: {},
            highlightedTitle: messageResource.getEscapedMessage("panel.common.archived_tasks", [countCompletedTask]),
            additionalClass: "customer_row_archived",
        })
    )

    return nodeProperties
}


export const getCustomerWaEntities = (ids, customers, manageCustomersIds, manageCustomersExcludingSelfIds) => {
    const customerEntities = []
    for (const id of ids) {
        const customer = customers[id]
        const cannotRevokeCustomer = manageCustomersIds[customer.id] || manageCustomersExcludingSelfIds[customer.id]
        const customerProperty = {
            id: customer.id,
            type: HierarchyLevels.CUSTOMER,
            title: customer.name,
            archived: customer.archived,
            revokeEnabled: !cannotRevokeCustomer,
            maExcludeSelf: manageCustomersExcludingSelfIds[customer.id],
        }
        customerEntities.push(customerProperty)
    }
    return customerEntities
}

export const getCustomerMaEntities = (ids, customers, manageCustomersIds, manageCustomersExcludingSelfIds) => {
    const customerEntities = []
    for (const id of ids) {
        const customer = customers[id]
        const customerProperty = {
            id: customer.id,
            type: HierarchyLevels.CUSTOMER,
            title: customer.name,
            archived: customer.archived,
            revokeEnabled: true,
            maExcludeSelf: manageCustomersExcludingSelfIds[customer.id],
        }
        customerEntities.push(customerProperty)
    }
    return customerEntities
}

export const getProjectMaEntities = (
    ids,
    projects,
    customers,
    manageProjectsIds,
    manageProjectsExcludingSelfIds,
    manageCustomersIds,
    manageCustomersExcludingSelfIds
) => {
    const nodeProperties = []
    let prevCustomerId = null
    let prevCustomerIndex = null

    for (let id of ids) {
        const project = projects[id]
        if (prevCustomerId !== project.customerId) {
            const customer = customers[project.customerId]
            prevCustomerId = project.customerId
            prevCustomerIndex = nodeProperties.length
            nodeProperties.push({
                id: prevCustomerId,
                type: HierarchyLevels.CUSTOMER,
                revokeEnabled: true,
                title: customer.name,
                archived: customer.archived,
                numberOfProjects: 0,
                maExcludeSelf: manageCustomersExcludingSelfIds[prevCustomerId],
            })
        }

        nodeProperties[prevCustomerIndex].numberOfProjects += 1
        const cannotRevokeProject = manageCustomersIds[prevCustomerId]
        nodeProperties.push({
            id: project.id,
            title: project.name,
            type: HierarchyLevels.PROJECT,
            archived: project.archived,
            revokeEnabled: !cannotRevokeProject,
            maExcludeSelf: manageProjectsExcludingSelfIds[project.id],
        })
    }
    return nodeProperties
}

export const getProjectWaEntities = (
    ids,
    projects,
    customers,
    manageProjectsIds,
    manageProjectsExcludingSelfIds,
    manageCustomersIds,
    manageCustomersExcludingSelfIds
) => {
    const nodeProperties = []
    let prevCustomerId = null
    let prevCustomerIndex = null

    for (let id of ids) {
        const project = projects[id]
        const customerId = project.customerId
        const cannotRevokeCustomer = manageCustomersIds[customerId] || manageCustomersExcludingSelfIds[customerId]
        if (prevCustomerId !== customerId) {
            const customer = customers[customerId]
            prevCustomerId = customerId
            prevCustomerIndex = nodeProperties.length
            nodeProperties.push({
                id: prevCustomerId,
                type: HierarchyLevels.CUSTOMER,
                revokeEnabled: !cannotRevokeCustomer,
                title: customer.name,
                archived: customer.archived,
                numberOfProjects: 0,
                maExcludeSelf: manageCustomersExcludingSelfIds[prevCustomerId],
            })
        }

        nodeProperties[prevCustomerIndex].numberOfProjects += 1
        const cannotRevokeProject = cannotRevokeCustomer
                                    || manageProjectsIds[project.id]
                                    || manageProjectsExcludingSelfIds[project.id]
        nodeProperties.push({
            id: project.id,
            title: project.name,
            type: HierarchyLevels.PROJECT,
            archived: project.archived,
            revokeEnabled: !cannotRevokeProject,
            maExcludeSelf: manageProjectsExcludingSelfIds[project.id],
        })
    }
    return nodeProperties
}

export const getTaskWaEntities = (
    ids,
    tasks,
    projects,
    customers,
    manageTasksIds,
    manageProjectsIds,
    manageProjectsExcludingSelfIds,
    manageCustomersIds,
    manageCustomersExcludingSelfIds
) => {
    const nodeProperties = []
    let prevCustomerId = null
    let prevCustomerIndex = null

    let prevProjectId = null
    let prevProjectIndex = null

    for (let id of ids) {
        const task = tasks[id]
        const project = projects[task.projectId]
        const customerId = project.customerId
        const customer = customers[customerId]

        const cannotRevokeCustomer = manageCustomersIds[customerId] || manageCustomersExcludingSelfIds[customerId]
        if (prevCustomerId !== customerId) {
            prevCustomerIndex = nodeProperties.length
            prevCustomerId = customerId
            nodeProperties.push({
                id: prevCustomerId,
                title: customer.name,
                archived: customer.archived,
                type: HierarchyLevels.CUSTOMER,
                revokeEnabled: !cannotRevokeCustomer,
                maExcludeSelf: manageCustomersExcludingSelfIds[prevCustomerId],
            })
        }

        const cannotRevokeProject = cannotRevokeCustomer
                                    || manageProjectsIds[prevProjectId]
                                    || manageProjectsExcludingSelfIds[prevProjectId]
        if (prevProjectId !== task.projectId) {
            prevProjectIndex = nodeProperties.length
            prevProjectId = task.projectId
            nodeProperties.push({
                id: prevProjectId,
                title: project.name,
                type: HierarchyLevels.PROJECT,
                archived: project.archived,
                revokeEnabled: !cannotRevokeProject,
                numberOfTasks: 0,
                maExcludeSelf: manageProjectsExcludingSelfIds[prevProjectId],
            })
        }
        const cannotRevokeTask = cannotRevokeProject || manageTasksIds[task.id]

        nodeProperties[prevProjectIndex].numberOfTasks += 1

        nodeProperties.push({
            id: task.id,
            title: task.name,
            completed: task.completed,
            type: HierarchyLevels.TASK,
            revokeEnabled: !cannotRevokeTask,
        })
    }
    return nodeProperties
}

export const getTaskMaEntities = (
    ids,
    tasks,
    projects,
    customers,
    manageTasksIds,
    manageProjectsIds,
    manageProjectsExcludingSelfIds,
    manageCustomersIds,
    manageCustomersExcludingSelfIds
) => {
    const nodeProperties = []
    let prevCustomerId = null
    let prevCustomerIndex = null

    let prevProjectId = null
    let prevProjectIndex = null

    for (let id of ids) {
        const task = tasks[id]
        const project = projects[task.projectId]
        const customer = customers[project.customerId]

        if (prevCustomerId !== project.customerId) {
            prevCustomerIndex = nodeProperties.length
            prevCustomerId = project.customerId
            nodeProperties.push({
                id: prevCustomerId,
                title: customer.name,
                archived: customer.archived,
                type: HierarchyLevels.CUSTOMER,
                revokeEnabled: true,
                maExcludeSelf: manageCustomersExcludingSelfIds[prevCustomerId],
            })
        }

        if (prevProjectId !== task.projectId) {
            prevProjectIndex = nodeProperties.length
            prevProjectId = task.projectId

            nodeProperties.push({
                id: prevProjectId,
                title: project.name,
                type: HierarchyLevels.PROJECT,
                archived: project.archived,
                revokeEnabled: !manageCustomersIds[prevCustomerId],
                numberOfTasks: 0,
                maExcludeSelf: manageProjectsExcludingSelfIds[prevProjectId],
            })
        }
        const cannotRevokeTask = manageProjectsIds[prevProjectId] || manageCustomersIds[prevCustomerId]
        nodeProperties[prevProjectIndex].numberOfTasks += 1

        nodeProperties.push({
            id: task.id,
            title: task.name,
            completed: !task.open,
            type: HierarchyLevels.TASK,
            revokeEnabled: !cannotRevokeTask,
        })
    }
    return nodeProperties
}

export const getSortedTaskIdsByName = (ids, tasks, projects, customers) => {
    return ids.map(id => {
        const task = tasks[id]
        const project = projects[task.projectId]
        const customer = customers[project.customerId]

        return {
            id,
            taskName: task.name,
            projectName: project.name,
            customerName: customer.name,
            customerArchived: customer.archived,
            projectArchived: project.archived,
            taskCompleted: !task.open,
        }
    }).sort(customerProjectTaskComparator).map(e => e.id)
}

export const getSortedProjectIdsByName = (ids, projects, customers) => {
    return ids.map(id => {
        const project = projects[id]
        const customer = customers[project.customerId]

        return {
            id,
            projectName: project.name,
            customerName: customer.name,
            customerArchived: customer.archived,
            projectArchived: project.archived,
        }
    }).sort(customerProjectComparator).map(e => e.id)
}

export const getSortedCustomerIdsByName = (ids, customers) => (
    ids.map(id => {
        const customer = customers[id]

        return {
            id,
            customerName: customer.name,
            customerArchived: customer.archived,
        }
    }).sort(customerComparator).map(e => e.id)
)

const customerNameComparator = (a, b) => stringComparator(a.customerName, b.customerName)
const projectNameComparator = (a, b) => stringComparator(a.projectName, b.projectName)
const taskNameComparator = (a, b) => stringComparator(a.taskName, b.taskName)

const customerComparator = (a, b) => archivedComparator(a.customerArchived, b.customerArchived)
                                     || customerNameComparator(a, b)

const customerProjectComparator = (a, b) => archivedComparator(a.customerArchived, b.customerArchived)
                                            || archivedComparator(a.projectArchived, b.projectArchived)
                                            || customerNameComparator(a, b)
                                            || projectNameComparator(a, b)

const customerProjectTaskComparator = (a, b) => archivedComparator(a.customerArchived, b.customerArchived)
                                                || archivedComparator(a.projectArchived, b.projectArchived)
                                                || archivedComparator(a.taskCompleted, b.taskCompleted)
                                                || customerNameComparator(a, b)
                                                || projectNameComparator(a, b)
                                                || taskNameComparator(a, b)

export const archivedComparator = (a, b) => {
    if (a === b) {
        return 0
    } else if (a) {
        return 1
    } else if (b) {
        return -1
    }
}

const getEntityAdditionalTitle = (type) => {
    if (type === HierarchyLevels.TASK) {
        return messageResource.getMessage("panel.common.Completed")
    }

    return messageResource.getMessage("panel.common.Archived")
}

const isEntityArchived = (entity) => {
    return entity.type === HierarchyLevels.TASK ? entity.completed : entity.archived
}

const getNodeProperty = ({
    entity,
    highlightedTitle,
    isShowArchived,
    revokeCallback,
    note,
    additionalClass,
    additionalClassArchived
}) => {
    return {
        ...entity,
        highlightedTitle: highlightedTitle,
        additionalTitle: isShowArchived && isEntityArchived(entity) ? getEntityAdditionalTitle(entity.type) : "",
        revokeCallback: revokeCallback,
        note: note || "",
        additionalClass: isShowArchived && isEntityArchived(entity) ? additionalClassArchived || "" : additionalClass || "",
        revokeEnabled: entity.revokeEnabled,
    }
}

const getNote = (entity, specificTextNoteKey) => {
    let note = ""
    if (entity.maExcludeSelf) {
        note = messageResource.getMessage(specificTextNoteKey)
    } else if (!entity.revokeEnabled) {
        note = messageResource.getMessage("work_assignments.panel.tab_row.note")
    }
    return note
}

const getNoteByHierarchyLevel = (level, entity) => {
    switch (level) {
        case HierarchyLevels.CUSTOMER:
            return getNote(entity, 'userlist.ha_editor.customers.can_manage_existing_and_future')
        case HierarchyLevels.PROJECT:
            return getNote(entity, 'userlist.ha_editor.projects.can_manage_existing_and_future')
        case HierarchyLevels.TASK:
            return entity.revokeEnabled ? "" : messageResource.getMessage("work_assignments.panel.tab_row.note")
    }
}

const getCustomerHighlightTitle = (level, entity, tokensHighlighter) => {
    switch (level) {
        case HierarchyLevels.CUSTOMER:
            return tokensHighlighter.highlightTokens(entity.title)
        case HierarchyLevels.PROJECT:
            return messageResource.getEscapedMessage(
                "work_assignments.panel.projects.customer_title",
                [
                    entity.title,
                    entity.numberOfProjects,
                    projectNameLower(entity.numberOfProjects)
                ]
            )
        case HierarchyLevels.TASK:
            return escapeHtmlSymbols(entity.title)
    }
}

const getProjectHighlightTitle = (level, entity, tokensHighlighter) => {
    switch (level) {
        case HierarchyLevels.PROJECT:
            return tokensHighlighter.highlightTokens(entity.title)
        case HierarchyLevels.TASK:
            return messageResource.getEscapedMessage(
                "work_assignments.panel.tasks.project_title",
                [
                    entity.title,
                    entity.numberOfTasks,
                    taskNameLower(entity.numberOfTasks)
                ])
    }
}

const getCustomerNodeProperty = ({entity, isShowArchived, tokensHighlighter, customerRevoked, hierarchyLevel}) => {

    let greyRowClass = hierarchyLevel !== HierarchyLevels.CUSTOMER ? " grey_row" : ""

    return getNodeProperty({
        entity,
        isShowArchived,
        note: getNoteByHierarchyLevel(hierarchyLevel, entity),
        highlightedTitle: getCustomerHighlightTitle(hierarchyLevel, entity, tokensHighlighter),
        revokeCallback: customerRevoked,
        additionalClass: "customer_row" + greyRowClass,
        additionalClassArchived: "customer_row_archived"
    })
}

const getProjectNodeProperty = ({entity, isShowArchived, tokensHighlighter, projectRevoked, hierarchyLevel}) => {

    let greyRowClass = hierarchyLevel === HierarchyLevels.TASK ? " grey_row" : ""

    return getNodeProperty({
        entity,
        isShowArchived,
        note: getNoteByHierarchyLevel(hierarchyLevel, entity),
        highlightedTitle: getProjectHighlightTitle(hierarchyLevel, entity, tokensHighlighter),
        revokeCallback: projectRevoked,
        additionalClass: "project_row" + greyRowClass,
        additionalClassArchived: "project_row_archived" + greyRowClass
    })
}

const getTaskNodeProperty = ({entity, isShowArchived, tokensHighlighter, taskRevoked}) => {
     return getNodeProperty({
        entity,
        isShowArchived,
        note: entity.revokeEnabled ? "" : messageResource.getMessage("work_assignments.panel.tab_row.note"),
        highlightedTitle: tokensHighlighter.highlightTokens(entity.title),
        revokeCallback: taskRevoked,
        additionalClass: "task_row",
        additionalClassArchived: "task_row_completed"
    })
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/hierarchyAssignmentsPanelTab/utils.js